import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { UploadChangeParam, UploadFile } from "ng-zorro-antd/upload";
import { Observable, Observer } from "rxjs";
import { KreFormAntService } from "../tools/service";
import * as _ from "lodash";

@Component({
  selector: "krefield-upload",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <nz-upload nzType="drag" [nzDisabled]="true">
          <p class="ant-upload-drag-icon"></p>
          <p class="ant-upload-text">单击或拖动文件到此区域上传</p>
          <p class="ant-upload-hint">
            支持单个或批量上传。严禁上传不法文件，谢谢!
          </p>
        </nz-upload>
      </div>
    </ng-container>

    <ng-template #other>
      <nz-upload
        nzType="drag"
        nzAction="https://jsonplaceholder.typicode.com/posts/"
        [nzFileList]="defaultFileList"
        [nzMultiple]="true"
        (nzChange)="handleChange($event)"
        [class.is-invalid]="showError"
      >
        <p class="ant-upload-drag-icon"></p>
        <p class="ant-upload-text">单击或拖动文件到此区域上传</p>
        <p class="ant-upload-hint">
          支持单个或批量上传。严禁上传不法文件，谢谢!
        </p>
      </nz-upload>
      <div class="tips"></div>
    </ng-template>
  `,
})
export class KreFormFieldUpload extends FieldType {
  defaultFileList = [];
  constructor(public msg: NzMessageService) {
    super();
  }

  handleChange({ file, fileList }: UploadChangeParam): void {
    const status = file.status;
    if (status !== "uploading") {
    }
    if (status === "done") {
      let values: any = fileList.map((item: any) => {
        return {
          uid: item.uid,
          name: item.name,
          url: item.url,
        };
      });
      /* this.model[this.field.key] = values;
      this.formControl.markAsTouched(); */
      this.formControl.patchValue(values);
      this.formControl.markAsTouched();
      this.msg.success(`文件${file.name} 上传成功！`);
    } else if (status === "error") {
      this.msg.error(`文件${file.name} 上传失败！`);
    }
    if (status === "removed") {
      let values: any = this.formControl.value;
      values.forEach((item: any, index: any, object: any) => {
        if (item.uid === file.uid) {
          object.splice(index, 1);
        }
      });

      //this.formControl.patchValue(values);
      //this.formControl.markAsTouched();
      this.msg.success(`文件${file.name} 删除成功！`);
    }
  }

  handleRemove = (file: any) =>
    new Observable<boolean>((observer) => {
      observer.next(true);
      observer.complete();
    });

  beforeUpload = (file: File) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJPG = file.type === "image/jpeg";
      if (!this.checkFileType(file)) {
        this.msg.error("您上传的文件类型不符合要求！");
        observer.complete();
        return;
      }
      if (!this.checkFileSize(file)) {
        this.msg.error("您上传的文件大小已经超出最大设置");
        observer.complete();
        return;
      }
      observer.next(true);
      observer.complete();
    });
  };

  checkFileType(file: File) {
    let result: boolean = true;
    if (
      this.field &&
      this.field.templateOptions &&
      this.field.templateOptions.attachment &&
      this.field.templateOptions.attachment.type
    ) {
      let types: any = this.field.templateOptions.attachment.type;
      if (types != undefined && types != null && types != "") {
        result = types.split(",").some((item: any) => {
          return file.type === item;
        });
      }
    }
    return result;
  }

  checkFileSize(file: File) {
    let result: boolean = true;
    if (
      this.field &&
      this.field.templateOptions &&
      this.field.templateOptions.attachment &&
      this.field.templateOptions.attachment.size
    ) {
      let size: any = this.field.templateOptions.attachment.size;
      if (size != undefined && size != null) {
        result = file.size / 1024 / 1024 <= size;
      }
    }
    return result;
  }
}
